import { render, staticRenderFns } from "./MobileMenuItem.vue?vue&type=template&id=5880138e&scoped=true"
import script from "./MobileMenuItem.vue?vue&type=script&lang=js"
export * from "./MobileMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MobileMenuItem.vue?vue&type=style&index=0&id=5880138e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880138e",
  null
  
)

export default component.exports